import { render, staticRenderFns } from "./ModalPrevalidateAfterImageDialog.vue?vue&type=template&id=772ccf64&"
import script from "./ModalPrevalidateAfterImageDialog.vue?vue&type=script&lang=js&"
export * from "./ModalPrevalidateAfterImageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports